import { useContext } from "react";
import { VideoContext } from "../../context/video_context";
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle_group";
import { cn } from "../../lib/utils";

const DURATION_OPTIONS = [
  { value: "1day", label: "1 Day" },
  { value: "2days", label: "2 Days" },
  { value: "3days", label: "3 Days" },
  { value: "1week", label: "1 Week" },
  { value: "2weeks", label: "2 Weeks" },
];

export default function TestOptions() {
  const videoContext = useContext(VideoContext);
  const useOriginal = videoContext?.useOriginal || false;
  const setUseOriginal = videoContext?.setUseOriginal || (() => {});
  const alignment = videoContext?.alignment || null;
  const setAlignment = videoContext?.setAlignment || (() => {});

  return (
    <div className="flex flex-wrap gap-8 py-4">
      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Include original thumbnail</span>
        <label className="flex items-center gap-3 cursor-pointer">
          <div className="relative">
            <input
              type="checkbox"
              checked={useOriginal}
              onChange={(e) => setUseOriginal(e.target.checked)}
              className="sr-only peer"
            />
            <div
              className={cn(
                "w-10 h-6 rounded-full transition-colors",
                useOriginal ? "bg-primary" : "bg-muted"
              )}
            />
            <div
              className={cn(
                "absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform",
                useOriginal ? "translate-x-4" : "translate-x-0"
              )}
            />
          </div>
          <span className="text-sm text-muted-foreground">{useOriginal ? "On" : "Off"}</span>
        </label>
      </div>

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Days Per Thumbnail</span>
        <ToggleGroup
          type="single"
          value={alignment ?? ""}
          onValueChange={(val) => {
            if (val) setAlignment(val);
          }}
          variant="outline"
          size="sm"
        >
          {DURATION_OPTIONS.map(({ value, label }) => (
            <ToggleGroupItem key={value} value={value} aria-label={label}>
              {label}
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
    </div>
  );
}
